import { render, staticRenderFns } from "./SignDocumentCard.vue?vue&type=template&id=31719682&"
import script from "./SignDocumentCard.vue?vue&type=script&lang=js&"
export * from "./SignDocumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports